import React from 'react';
import { BiddingInfoUrls as BiddingInfoUrlType } from '../../../store/modules/bidding_store/types';

interface BiddingInfoUrlsProps {
  urls: BiddingInfoUrlType[];
}

const BiddingInfoUrls: React.FC<BiddingInfoUrlsProps> = ({ urls }) => {
  if (urls.length === 0) return null;

  const baseUrl = `https://bidding-info-${process.env.NODE_ENV}.s3.us-east-1.amazonaws.com/`;

  return (
    <div className="card mt-3 p-2">
      <p className="font-weight-bold">Anexos</p>
      {urls.map((file) => (
        <div className="d-flex align-items-center" key={file?.filename}>
          <i className="material-icons mr-2">file_download</i>
          <a
            href={/^https?:\/\//.test(file?.url ?? '') ? file.url : `${baseUrl}${file?.url}`}
            download={file?.filename}
            className="text-decoration-none text-dark"
            target="_blank"
            rel="noreferrer"
          >
            {file?.filename}
          </a>
        </div>
      ))}
    </div>
  );
};

export default BiddingInfoUrls;
